import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const PromoteInstallmentsModalSlot = ({ siteLogos , price , isCentAmount , numberOfInstallments  })=>{
    const { getLabel , currency , locale  } = useIntl();
    const monthsIndexArray = React.useMemo(()=>{
        return Array(numberOfInstallments - 1).fill(0).map((_, index)=>index + 1
        );
    }, [
        numberOfInstallments
    ]);
    if (numberOfInstallments <= 1) {
        return null;
    }
    const logo = /*#__PURE__*/ React.createElement("img", {
        src: siteLogos.payInstallmentsLogo,
        alt: getLabel('installments.modal.logoAlt')
    });
    const pricePerMonthValue = isCentAmount ? Math.floor(price / numberOfInstallments) : Number((price / numberOfInstallments).toFixed(2));
    // First month can be slightly different due to rounding errors. Make sure it all adds up to the total price
    const priceNow = formatPrice({
        locale,
        value: price - (numberOfInstallments - 1) * pricePerMonthValue,
        currency,
        isCentAmount
    });
    const pricePerMonth = formatPrice({
        locale,
        value: pricePerMonthValue,
        currency,
        isCentAmount
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot",
        "data-t": "promote-installments-modal"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot__intro"
    }, /*#__PURE__*/ React.createElement("p", null, getLabel('installments.modal.partnerDescription'), " ", logo)), /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot__steps-wrapper"
    }, /*#__PURE__*/ React.createElement("p", null, getLabel('installments.modal.stepsTitle')), /*#__PURE__*/ React.createElement("ol", {
        className: "promote-installments-modal-slot__steps"
    }, /*#__PURE__*/ React.createElement("li", {
        className: "promote-installments-modal-slot__step"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "promote-installments-modal-slot__step-number"
    }, "1"), /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.step1'))), /*#__PURE__*/ React.createElement("li", {
        className: "promote-installments-modal-slot__step"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "promote-installments-modal-slot__step-number"
    }, "2"), /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.step2')), logo && /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot__step-logo"
    }, logo)), /*#__PURE__*/ React.createElement("li", {
        className: "promote-installments-modal-slot__step"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "promote-installments-modal-slot__step-number"
    }, "3"), /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.step3'))), /*#__PURE__*/ React.createElement("li", {
        className: "promote-installments-modal-slot__step"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "promote-installments-modal-slot__step-number"
    }, "4"), /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.step4'))))), /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot__pay"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot__pay-now"
    }, /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.payNow')), /*#__PURE__*/ React.createElement("div", null, priceNow, " ", getLabel('installments.modal.payNowMethod')), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.payNowMethodDescription'))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "promote-installments-modal-slot__pay-summary-description"
    }, /*#__PURE__*/ React.createElement("div", null, getLabel('installments.modal.summaryTitle'))), /*#__PURE__*/ React.createElement("dl", {
        className: "promote-installments-modal-slot__pay-summary",
        "data-t": "promote-installments-payment-summary"
    }, /*#__PURE__*/ React.createElement("dt", null, getLabel('installments.modal.summaryDescriptionNow')), /*#__PURE__*/ React.createElement("dd", null, priceNow), monthsIndexArray.map((index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement("dt", null, getLabel(`installments.modal.summaryDescription${index}`)), /*#__PURE__*/ React.createElement("dd", null, pricePerMonth))
    )))));
};

export { PromoteInstallmentsModalSlot };
//# sourceMappingURL=PromoteInstallmentsModalSlot.js.map
